export default __webpack_public_path__ + "static/media/volunteer.0b9d39bb.png";